import {
  Grid,
  IconButton,
  LinearProgress,
  Card,
  CardContent,
  Stack,
  Tooltip,
  Typography,
  Button,
  TextField,
  useMediaQuery,
  Paper,
  Chip,
  Avatar,
  Fade,
  alpha,
} from "@mui/material";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  JOrder,
  setAddItemToOrderDialog,
  setAdminDiscountDialog,
  setAssignDriverDialog,
  setChangeAdminNoteDialog,
  setChangePosDialog,
  setLoading,
  setOrderChangeHistoryDialog,
  setOrderItemChangeHistoryDialog,
  setOrderItemDiscountDialog,
  setOrderPrintDialog,
  setOrderStatusHistoryDialog,
} from "../../../../../app/slices/jomla/orderSlice";
import dayjs from "dayjs";
import {
  HiOutlinePencilSquare,
  HiOutlinePhoto,
  HiOutlineReceiptPercent,
  HiOutlineShoppingBag,
  HiOutlineXCircle,
} from "react-icons/hi2";
import {
  BRAND,
  BRAND_GRADIENT,
  MobileAction,
  MobileBadge,
  MobileListItem,
  MobileListShell,
  MobileSectionTitle,
  TONE,
} from "../../../../../components/MobileList";
import { ChangeStatusByChip } from "./ChangeStatusByChip";
import { useParams } from "react-router";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { MdList, MdOutlineCancel, MdOutlineHistory } from "react-icons/md";
import {
  FaCartPlus,
  FaEye,
  FaMoneyBillWave,
  FaTicketAlt,
} from "react-icons/fa";
import { BiEdit, BiInfoCircle } from "react-icons/bi";
import EditAdminDiscountForm from "../../form/editAdminDiscountForm";
import { NumericFormat } from "react-number-format";
import { toNumber } from "../../../../../helpers/toNumber";
import EditOrderItemDiscountForm from "../../form/orderItemDiscountForm";
import { PointOfSales } from "../../../../../app/slices/posSlice";
import PosForm from "../../../../POS/form";
import AddItemToOrderForm from "../../form/addItemToOrder";
import AssignOrderToDriverForm from "../../form/assignDriver";
import { Carousel } from "react-responsive-carousel";
import OrderStatusHistoryDialog from "../../form/orderStatusHistory";
import OrderPrintDialog from "../../form/orderPrint";
import { useTheme } from "@emotion/react";
import ChangePosForm from "../../form/changePos";
import ChangeAdminNoteForm from "../../form/changeAdminNote";
import OrderItemChangeHistoryDialog from "../../form/orderItemChangeHistoryDialog";
import OrderChangeHistoryDialog from "../../form/orderChangeHistoryDialog";
import Permission from "../../../../../components/userPermission/userPermission";
import FormDialog, {
  PlainCard,
  SectionCard,
} from "../../../../../components/FormDialog";

const JOrderDetails = () => {
  const { order_id } = useParams();
  const dispatch = useDispatch();

  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"));

  // Helper function to detect duplicate items based on code
  const findDuplicateItems = (items) => {
    const codeGroups = {};
    items?.forEach((item, index) => {
      if (item.code) {
        if (!codeGroups[item.code]) {
          codeGroups[item.code] = [];
        }
        codeGroups[item.code].push({ ...item, originalIndex: index });
      }
    });

    const duplicates = new Set();
    Object.keys(codeGroups).forEach((code) => {
      if (codeGroups[code].length > 1) {
        codeGroups[code].forEach((item) => {
          duplicates.add(item.id);
        });
      }
    });

    return duplicates;
  };

  const _Role = useSelector((state) => state.user.userInfo.user_roles[0]);
  const _UserInfo = useSelector((state) => state.user.userInfo);
  const PRIVILEGED_USER_ID = "ca40271f-cd02-4f18-b48a-83ae2e2b6fef";
  const adminDiscountDialog = useSelector(
    (state) => state.jOrder.adminDiscount.dialog
  );

  const orderItemDiscountDialog = useSelector(
    (state) => state.jOrder.orderItemDiscount.dialog
  );
  const addItemToOrderDialog = useSelector(
    (state) => state.jOrder.addItemToOrder.dialog
  );
  const assignDriverDialog = useSelector(
    (state) => state.jOrder.assignDriver.dialog
  );
  const changePosDialog = useSelector((state) => state.jOrder.changePos.dialog);
  const _JOrderStatusDialog = useSelector(
    (state) => state.jOrder.orderStatusHistory.dialog
  );
  const _JOrderPrintDialog = useSelector(
    (state) => state.jOrder.orderPrint.dialog
  );
  const changeAdminNoteDialog = useSelector(
    (state) => state.jOrder.changeAdminNote.dialog
  );
  const _JOrder = useSelector((state) => state.jOrder.jOrder.details);
  const loading = useSelector((state) => state.jOrder.jOrders.loading);
  const _SearchBody = useSelector((state) => state.jOrder.searchBody);
  const _PointsOfSales = useSelector((state) => state.pointOfsales);
  const _JOrderItemChangeHistory = useSelector(
    (state) => state.jOrder.orderItemChangeHistory.dialog
  );
  const _JOrderChangeHistory = useSelector(
    (state) => state.jOrder.orderChangeHistory.dialog
  );

  useEffect(() => {
    dispatch(JOrder.getOrderDetails(order_id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order_id]);

  const [itemCount, setItemCount] = useState("");
  const [itemNote, setItemNote] = useState("");
  const [discountedItemPrice, setDiscountedItemPrice] = useState("");
  const [openItemDialog, setOpenItemDialog] = useState(false);
  const [dialogData, setDialogData] = useState("");
  const [dialogType, setDialogType] = useState("");
  const [openCarouselDialog, setOpenCarouselDialog] = useState(false);
  const [attachmentsData, setAttachmentsData] = useState([]);

  const changeOrderStatus = (id, status) => {
    let params = {
      j_order_status_id: status?.id,
    };
    dispatch(JOrder.updateStatus(id, params, _SearchBody, "getById"));
  };

  // Get duplicate items
  const duplicateItems = findDuplicateItems(_JOrder.items);

  const columns = [
    {
      field: "index",
      headerName: "#",
      flex: 0.3,
    },
    {
      field: "logo",
      headerName: "الصورة",
      flex: 1,
      renderCell: (params) => (
        <Box
          component="img"
          src={params.row.logo[0]?.path}
          width={100}
          height={100}
          sx={{ objectFit: "contain" }}
          onClick={() => {
            setAttachmentsData(params.row.logo);
            setOpenCarouselDialog(true);
          }}
        />
      ),
    },
    {
      field: "j_item_name",
      headerName: "اسم المنتج",
      flex: 2,
      renderCell: (params) => (
        <Stack spacing={2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body1" component="div">
              {params.row.code ? `Code:  ${params.row.code}` : ""}
            </Typography>
            {duplicateItems.has(params.row.id) && (
              <Tooltip title="منتج مكرر - يوجد منتج آخر بنفس الكود">
                <Chip
                  label="مكرر"
                  size="small"
                  sx={{
                    bgcolor: "warning.main",
                    color: "white",
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                  }}
                />
              </Tooltip>
            )}
          </Stack>
          <Typography
            variant="body1"
            color="primary"
            component="div"
            style={{
              whiteSpace: "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textDecoration: params.row.is_canceled
                ? "line-through red"
                : "none",
              textDecorationThickness: params.row.is_canceled
                ? "1.5px"
                : "initial",
            }}
          >
            {params.row.j_item_name}
          </Typography>
          <Typography
            style={{
              textDecoration: params.row.is_canceled
                ? "line-through red"
                : "none",
              textDecorationThickness: params.row.is_canceled
                ? "1.5px"
                : "initial",
            }}
          >
            {params.row.j_sub_category_name}
          </Typography>
          <Typography color={"error"}>{params.row.expiry_date}</Typography>
          <Typography variant="caption">
            في المخزن: {params.row.j_item_stock_count}
          </Typography>
        </Stack>
      ),
    },
    {
      field: "price_before_discount",
      headerName: "السعر قبل الخصم",
      flex: 1,
      renderCell: (params) => (
        <Stack>
          <Typography
            style={{
              textDecoration: params.row.is_canceled
                ? "line-through red"
                : "none",
              textDecorationThickness: params.row.is_canceled
                ? "1.5px"
                : "initial",
            }}
          >
            {params.row.price_before_discount?.toLocaleString()}
          </Typography>
          {_Role === "super_admin" ||
          (_UserInfo && _UserInfo.id === PRIVILEGED_USER_ID) ? (
            <Typography variant="caption">
              سعر الشراء {params.row.last_buying_price?.toLocaleString()}
            </Typography>
          ) : null}
        </Stack>
      ),
    },
    {
      field: "discount_for_one",
      headerName: "الخصم للقطعة ",
      flex: 1,
      renderCell: (params) => (
        <Typography
          style={{
            textDecoration: params.row.is_canceled
              ? "line-through red"
              : "none",
            textDecorationThickness: params.row.is_canceled
              ? "1.5px"
              : "initial",
          }}
        >
          {params.row.discount_for_one?.toLocaleString()}
        </Typography>
      ),
    },
    {
      field: "price",
      headerName: "سعر المنتج",
      flex: 1,
      renderCell: (params) => (
        <Typography
          style={{
            textDecoration: params.row.is_canceled
              ? "line-through red"
              : "none",
            textDecorationThickness: params.row.is_canceled
              ? "1.5px"
              : "initial",
          }}
        >
          {params.row.price?.toLocaleString()}
        </Typography>
      ),
    },
    {
      field: "count",
      headerName: "العدد",
      flex: 0.5,
      renderCell: (params) => (
        <Stack direction={"row"} spacing={1}>
          <Typography
            variant="h4"
            color={
              params.row.j_item_stock_count < params.row.count ? "red" : "black"
            }
            style={{
              textDecoration: params.row.is_canceled
                ? "line-through red"
                : "none",
              textDecorationThickness: params.row.is_canceled
                ? "1.5px"
                : "initial",
            }}
          >
            {params.row.count?.toLocaleString()}
          </Typography>
          {params.row.note && (
            <Tooltip title={params.row.note}>
              <IconButton size="small" color="error">
                <BiInfoCircle />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      ),
    },
    {
      field: "total_discount",
      headerName: "الخصم الكلي",
      flex: 1,
      renderCell: (params) => (
        <Typography
          style={{
            textDecoration: params.row.is_canceled
              ? "line-through red"
              : "none",
            textDecorationThickness: params.row.is_canceled
              ? "1.5px"
              : "initial",
          }}
        >
          {params.row.total_discount?.toLocaleString()}
        </Typography>
      ),
    },
    {
      field: "total",
      headerName: "المبلغ الكلي",
      flex: 1,
      renderCell: (params) => (
        <Typography
          style={{
            textDecoration: params.row.is_canceled
              ? "line-through red"
              : "none",
            textDecorationThickness: params.row.is_canceled
              ? "1.5px"
              : "initial",
          }}
        >
          {params.row.total?.toLocaleString()}
        </Typography>
      ),
    },
    ...(_Role === "super_admin" || _UserInfo?.id === PRIVILEGED_USER_ID
      ? [
          {
            field: "net_revenue",
            headerName: "صافي الربح (IQD)",
            flex: 1,
            renderCell: (params) => (
              <Typography
                style={{
                  textDecoration: params.row.is_canceled
                    ? "line-through red"
                    : "none",
                  textDecorationThickness: params.row.is_canceled
                    ? "1.5px"
                    : "initial",
                }}
              >
                {toNumber(params.row.net_revenue)?.toLocaleString()}
              </Typography>
            ),
          },
        ]
      : []),
    // {
    //   field: "main_j_balance",
    //   headerName: "الخزنة (IQD)",
    //   flex: 1,
    //   renderCell: (params) =>
    //     <Stack alignItems='start'>
    //       <Typography variant="body" textAlign='center'>قبل: {params.row.main_j_balance?.toLocaleString()}</Typography>
    //       <Typography variant="body" textAlign='center'>بعد: {params.row.new_main_j_balance?.toLocaleString()}</Typography>
    //     </Stack>,
    // },
    {
      field: "operations",
      headerName: "العمليات",
      flex: 1,
      renderCell: (params) => (
        <Stack
          direction="row"
          spacing={0}
          alignItems="center"
          justifyContent="center"
        >
          <Stack>
            {params.row.j_order_item_history?.length > 0 ? (
              <Tooltip title="سجل التعديلات لهذا المنتج">
                <IconButton
                  onClick={() => {
                    dispatch(
                      setOrderItemChangeHistoryDialog(
                        params.row.j_order_item_history
                      )
                    );
                  }}
                >
                  <MdOutlineHistory size={25} />
                </IconButton>
              </Tooltip>
            ) : null}
            {params.row.is_canceled ? (
              <Tooltip title={"ملغي: " + params.row.note}>
                <Typography color="error">
                  <IoIosInformationCircleOutline size={25} />
                </Typography>
              </Tooltip>
            ) : null}
            {params.row.is_canceled ? null : (
              <Tooltip title="تعديل الكمية">
                <IconButton
                  onClick={() => {
                    setDialogType("update");
                    setItemCount(params.row.count);
                    setOpenItemDialog(true);
                    setDialogData(params.row);
                  }}
                >
                  <FaCartPlus />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
          <Stack>
            <Tooltip title="تعديل خصم العنصر">
              <IconButton
                color="success"
                onClick={() => {
                  dispatch(
                    setOrderItemDiscountDialog({
                      orderId: order_id,
                      id: params.row.id,
                      price: params.row.price,
                      price_before_discount: params.row.price_before_discount,
                      total_discount: 0,
                      total_discount_percent: 0,
                      // total_discount: params.row.total_discount,
                      // total_discount_percent:
                      //   Math.round(
                      //     (params.row.total_discount /
                      //       params.row.price_before_discount) *
                      //     100 *
                      //     100
                      //   ) / 100,
                    })
                  );
                }}
              >
                <FaTicketAlt />
              </IconButton>
            </Tooltip>
            <Tooltip
              title={params.row.is_canceled ? "استرداد المادة" : "الغاء المادة"}
            >
              <IconButton
                color={params.row.is_canceled ? "success" : "error"}
                onClick={() => {
                  setDialogType("cancel");
                  setItemCount(params.row.count);
                  setOpenItemDialog(true);
                  setDialogData(params.row);
                }}
              >
                <MdOutlineCancel />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>
      ),
    },
  ];

  useEffect(() => {
    dispatch(JOrder.getStatuses());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
        border: "1px solid",
        borderColor: "divider",
        overflow: "hidden",
        background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
      }}
    >
      <CardContent sx={{ p: 4 }}>
        {adminDiscountDialog ? <EditAdminDiscountForm /> : null}
        {orderItemDiscountDialog ? <EditOrderItemDiscountForm /> : null}
        {addItemToOrderDialog ? <AddItemToOrderForm /> : null}
        {assignDriverDialog ? (
          <AssignOrderToDriverForm orderDetails={true} />
        ) : null}
        {changePosDialog ? <ChangePosForm orderDetails={true} /> : null}
        {changeAdminNoteDialog ? (
          <ChangeAdminNoteForm orderDetails={true} />
        ) : null}
        {_PointsOfSales.pos.dialog ? (
          <PosForm from={"JOrderDetails"} jOrderId={order_id} />
        ) : null}
        {_JOrderStatusDialog ? <OrderStatusHistoryDialog /> : null}
        {_JOrderPrintDialog ? <OrderPrintDialog /> : null}
        {_JOrderItemChangeHistory ? <OrderItemChangeHistoryDialog /> : null}
        {_JOrderChangeHistory ? <OrderChangeHistoryDialog /> : null}
        <FormDialog
          open={openCarouselDialog}
          maxWidth="md"
          onClose={() => {
            setOpenCarouselDialog(false);
          }}
          icon={<HiOutlinePhoto />}
          title="صور المنتج"
        >
          <PlainCard>
            {/* ltr: the carousel slides break under the dialog's rtl */}
            <Box dir="ltr" display="flex" justifyContent="center" zIndex={999}>
              <Carousel
                swipeable
                emulateTouch
                infiniteLoop
                width={400}
                renderThumbs={(children) =>
                  children.map((child, index) => (
                    <img
                      key={index}
                      src={child.props.src}
                      alt=""
                      style={{
                        height: "50px",
                        width: "auto",
                        objectFit: "contain",
                        borderRadius: "8px",
                      }}
                    />
                  ))
                }
              >
                {attachmentsData?.map((attachment, index) => (
                  <Box
                    key={index}
                    component="img"
                    src={attachment.path}
                    alt=""
                    style={{
                      objectFit: "contain",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                ))}
              </Carousel>
            </Box>
          </PlainCard>
        </FormDialog>
        <FormDialog
          open={openItemDialog}
          maxWidth="sm"
          onClose={() => {
            setOpenItemDialog(false);
            setItemNote("");
            setItemCount("");
          }}
          icon={
            dialogType === "cancel" ? (
              <HiOutlineXCircle />
            ) : dialogType === "discount" ? (
              <HiOutlineReceiptPercent />
            ) : (
              <HiOutlinePencilSquare />
            )
          }
          title={
            dialogType === "update"
              ? "تعديل المنتج"
              : dialogType === "cancel"
              ? dialogData.is_canceled
                ? "استرداد المنتج"
                : "إلغاء المنتج"
              : dialogType === "discount"
              ? "تعديل سعر المنتج"
              : null
          }
          subtitle={dialogData.j_item_name}
          loading={loading}
          saving={loading}
          saveColor={
            dialogType === "cancel" && !dialogData.is_canceled
              ? "error"
              : "primary"
          }
          saveText={
            dialogType === "cancel"
              ? dialogData.is_canceled
                ? "استرداد المنتج"
                : "إلغاء المنتج"
              : "حفظ التغييرات"
          }
          onSubmit={(e) => {
            e.preventDefault();
            if (dialogType === "update") {
              dispatch(
                JOrder.updateOrderItemCount(
                  dialogData.id,
                  {
                    count: parseInt(itemCount),
                    note: itemNote,
                  },
                  order_id
                )
              ).then(() => {
                setOpenItemDialog(false);
                setItemNote("");
                setItemCount("");
                setDiscountedItemPrice("");
              });
            } else if (dialogType === "cancel") {
              // This will toggle cancel/restore based on current state
              dispatch(
                JOrder.cancelOrderItem(
                  dialogData.id,
                  {
                    note: itemNote,
                  },
                  order_id
                )
              ).then(() => {
                setOpenItemDialog(false);
                setItemNote("");
                setItemCount("");
                setDiscountedItemPrice("");
              });
            } else if (dialogType === "discount") {
              dispatch(
                JOrder.editOrderItemDiscount(
                  dialogData.id,
                  {
                    new_price: discountedItemPrice,
                  },
                  order_id
                )
              ).then(() => {
                setOpenItemDialog(false);
                setItemNote("");
                setItemCount("");
                setDiscountedItemPrice("");
              });
            }
          }}
        >
          <SectionCard>
            {dialogType === "cancel" && (
              <Grid item xs={12}>
                <Typography variant="body1" sx={{ opacity: 0.9 }}>
                  {dialogData.is_canceled
                    ? "هل أنت متأكد من استرداد هذا المنتج؟"
                    : "هل أنت متأكد من إلغاء هذا المنتج؟"}
                </Typography>
              </Grid>
            )}
            {dialogType === "update" ? (
              <Grid item xs={12}>
                <TextField
                  size="medium"
                  label="العدد"
                  value={itemCount}
                  type="number"
                  onChange={(e) => {
                    setItemCount(e.target.value);
                  }}
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>
            ) : null}
            {dialogType === "discount" ? null : (
              <Grid item xs={12}>
                <TextField
                  size="medium"
                  label="الملاحظات"
                  value={itemNote}
                  onChange={(e) => {
                    setItemNote(e.target.value);
                  }}
                  fullWidth
                  multiline
                  rows={4}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>
            )}

            {dialogType === "discount" ? (
              <Grid item xs={12}>
                <NumericFormat
                  thousandSeparator
                  customInput={TextField}
                  value={discountedItemPrice}
                  onChange={(e) => {
                    setDiscountedItemPrice(toNumber(e.target.value));
                  }}
                  valueIsNumericString={true}
                  allowNegative={false}
                  fullWidth
                  label="سعر العنصر الجديد"
                  size="medium"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>
            ) : null}
          </SectionCard>
        </FormDialog>
        <Grid container rowSpacing={3} columnSpacing={3}>
          <Grid item xs={12}>
            <Paper
              sx={{
                p: 3,
                borderRadius: 2,
                background: BRAND_GRADIENT,
                color: "white",
                position: "relative",
                overflow: "hidden",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background:
                    "linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)",
                  pointerEvents: "none",
                },
              }}
            >
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} md={5}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar
                      sx={{
                        bgcolor: "rgba(255,255,255,0.2)",
                        width: 56,
                        height: 56,
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                      }}
                    >
                      {_JOrder.user_name?.charAt(0) || "U"}
                    </Avatar>
                    <Box>
                      <Typography variant="h4" fontWeight="600" sx={{ mb: 1 }}>
                        {_JOrder.user_name}
                      </Typography>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="معلومات نقطة البيع" followCursor>
                          <IconButton
                            sx={{
                              color: "white",
                              bgcolor: "rgba(255,255,255,0.1)",
                              "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
                            }}
                            size="small"
                            onClick={() => {
                              dispatch(setLoading("jOrders"));
                              dispatch(
                                PointOfSales.getByUserId(_JOrder.user_id)
                              ).then(() => dispatch(setLoading("jOrders")));
                            }}
                          >
                            <FaEye />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="كشف الحساب" followCursor>
                          <IconButton
                            sx={{
                              color: "white",
                              bgcolor: "rgba(255,255,255,0.1)",
                              "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
                            }}
                            size="small"
                            onClick={() => {
                              localStorage.setItem("isWholeSale", "1");
                              window.open(
                                `/app/wallets/transactions/${_JOrder.user_id}`,
                                "_blank"
                              );
                            }}
                          >
                            <FaMoneyBillWave />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </Box>
                  </Stack>
                </Grid>
                <Grid item xs={12} md={7}>
                  <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "rgba(255,255,255,0.2)",
                        color: "white",
                        backdropFilter: "blur(10px)",
                        border: "1px solid rgba(255,255,255,0.1)",
                        "&:hover": {
                          bgcolor: "rgba(255,255,255,0.3)",
                          transform: "translateY(-1px)",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                        },
                        transition: "all 0.2s ease-in-out",
                      }}
                      onClick={() => {
                        dispatch(setOrderPrintDialog(_JOrder));
                      }}
                    >
                      طباعة فاتورة بيع
                    </Button>
                    <Permission
                      permission="assign_j_order_driver_edit"
                      role={["super_admin", "admin", "wholesale"]}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "rgba(255,255,255,0.2)",
                          color: "white",
                          backdropFilter: "blur(10px)",
                          border: "1px solid rgba(255,255,255,0.1)",
                          "&:hover": {
                            bgcolor: "rgba(255,255,255,0.3)",
                            transform: "translateY(-1px)",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                          },
                          transition: "all 0.2s ease-in-out",
                        }}
                        onClick={() => {
                          dispatch(
                            setAssignDriverDialog({
                              order_id: order_id,
                              driver_id: _JOrder.driver_id ?? null,
                            })
                          );
                        }}
                      >
                        {_JOrder.driver_name
                          ? "السائق: " + _JOrder.driver_name
                          : "تعيين سائق"}
                      </Button>
                    </Permission>
                    <Permission permission="j_order_item_edit">
                      {_JOrder?.j_order_status_id === 1 && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: "rgba(255,255,255,0.2)",
                            color: "white",
                            backdropFilter: "blur(10px)",
                            border: "1px solid rgba(255,255,255,0.1)",
                            "&:hover": {
                              bgcolor: "rgba(255,255,255,0.3)",
                              transform: "translateY(-1px)",
                              boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                            },
                            transition: "all 0.2s ease-in-out",
                          }}
                          onClick={() => {
                            dispatch(setAddItemToOrderDialog(order_id));
                          }}
                        >
                          اضافة منتجات للطلب
                        </Button>
                      )}
                    </Permission>
                    <Permission
                      permission="assign_j_order_driver_edit"
                      role={["super_admin", "admin", "wholesale"]}
                    >
                      {(_JOrder?.j_order_status_id === 1 ||
                        _JOrder?.j_order_status_id === 2 ||
                        _JOrder?.j_order_status_id === 3 ||
                        _JOrder?.j_order_status_id === 4) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: "rgba(255,255,255,0.2)",
                            color: "white",
                            backdropFilter: "blur(10px)",
                            border: "1px solid rgba(255,255,255,0.1)",
                            "&:hover": {
                              bgcolor: "rgba(255,255,255,0.3)",
                              transform: "translateY(-1px)",
                              boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                            },
                            transition: "all 0.2s ease-in-out",
                          }}
                          onClick={() => {
                            dispatch(
                              setChangePosDialog({
                                order_id: _JOrder.id,
                                user_id: _JOrder.user_id,
                                note: "",
                              })
                            );
                          }}
                        >
                          تغيير نقطة البيع
                        </Button>
                      )}
                    </Permission>
                    <Permission permission="j_order_admin_note_edit">
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "rgba(255,255,255,0.2)",
                          color: "white",
                          backdropFilter: "blur(10px)",
                          border: "1px solid rgba(255,255,255,0.1)",
                          "&:hover": {
                            bgcolor: "rgba(255,255,255,0.3)",
                            transform: "translateY(-1px)",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                          },
                          transition: "all 0.2s ease-in-out",
                        }}
                        onClick={() => {
                          dispatch(
                            setChangeAdminNoteDialog({
                              order_id: _JOrder.id,
                              admin_note: _JOrder.admin_note ?? "",
                            })
                          );
                        }}
                      >
                        ملاحظات الادمن
                      </Button>
                    </Permission>
                    {_JOrder?.j_order_history?.length > 0 && (
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: "rgba(255,255,255,0.2)",
                          color: "white",
                          backdropFilter: "blur(10px)",
                          border: "1px solid rgba(255,255,255,0.1)",
                          "&:hover": {
                            bgcolor: "rgba(255,255,255,0.3)",
                            transform: "translateY(-1px)",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                          },
                          transition: "all 0.2s ease-in-out",
                        }}
                        onClick={() => {
                          dispatch(
                            setOrderChangeHistoryDialog(_JOrder.j_order_history)
                          );
                        }}
                      >
                        سجل التعديلات لهذا الطلب
                      </Button>
                    )}
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "rgba(255,255,255,0.2)",
                        color: "white",
                        backdropFilter: "blur(10px)",
                        border: "1px solid rgba(255,255,255,0.1)",
                        "&:hover": {
                          bgcolor: "rgba(255,255,255,0.3)",
                          transform: "translateY(-1px)",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                        },
                        transition: "all 0.2s ease-in-out",
                      }}
                      onClick={() => {
                        dispatch(JOrder.recalculateJOrder(_JOrder.id, true));
                      }}
                    >
                      اعادة احتساب
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                background: alpha(BRAND, 0.08),
                border: `1px solid ${alpha(BRAND, 0.2)}`,
                borderRadius: 3,
                boxShadow: `0 8px 32px ${alpha(BRAND, 0.12)}`,
                transition: "all 0.3s ease-in-out",
                height: 400,
                display: "flex",
                flexDirection: "column",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: `0 12px 40px ${alpha(BRAND, 0.2)}`,
                },
              }}
            >
              <CardContent
                sx={{ p: 3, flex: 1, display: "flex", flexDirection: "column" }}
              >
                <Box
                  sx={{ mb: 2.5 }}
                  display={"flex"}
                  alignItems="center"
                  gap={2}
                >
                  <Typography
                    variant="h5"
                    fontWeight="700"
                    sx={{
                      color: BRAND,
                      fontSize: "1.3rem",
                      letterSpacing: "-0.02em",
                    }}
                  >
                    معلومات الطلب
                  </Typography>
                  <Chip
                    label={_JOrder.number}
                    size="medium"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: BRAND,
                      color: "white",
                      fontSize: "0.85rem",
                    }}
                  />
                </Box>

                <Stack spacing={2} sx={{ flex: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1.2,
                      px: 2,
                      bgcolor: "rgba(255, 255, 255, 0.6)",
                      borderRadius: 2,
                      border: `1px solid ${alpha(BRAND, 0.1)}`,
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="600"
                      sx={{ color: BRAND, fontSize: "1rem" }}
                    >
                      المبلغ قبل الخصم
                    </Typography>
                    <Typography
                      variant="h6"
                      fontWeight="700"
                      sx={{ color: BRAND, fontSize: "1.1rem" }}
                    >
                      {_JOrder.amount?.toLocaleString()} IQD
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1.2,
                      px: 2,
                      bgcolor: alpha(TONE.success, 0.08),
                      borderRadius: 2,
                      border: `1px solid ${alpha(TONE.success, 0.3)}`,
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="600"
                      sx={{ color: TONE.success, fontSize: "1rem" }}
                    >
                      المبلغ المدفوع
                    </Typography>
                    <Typography
                      variant="h6"
                      fontWeight="700"
                      sx={{ color: TONE.success, fontSize: "1.1rem" }}
                    >
                      {_JOrder.total_paid?.toLocaleString()} IQD
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1.2,
                      px: 2,
                      bgcolor: alpha(TONE.warning, 0.08),
                      borderRadius: 2,
                      border: `1px solid ${alpha(TONE.warning, 0.3)}`,
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="600"
                      sx={{ color: TONE.warning, fontSize: "1rem" }}
                    >
                      المبلغ المتبقي
                    </Typography>
                    <Typography
                      variant="h6"
                      fontWeight="700"
                      sx={{ color: TONE.warning, fontSize: "1.1rem" }}
                    >
                      {_JOrder.remaining?.toLocaleString()} IQD
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1.2,
                      px: 2,
                      bgcolor: "rgba(255, 255, 255, 0.6)",
                      borderRadius: 2,
                      border: `1px solid ${alpha(BRAND, 0.1)}`,
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="600"
                      sx={{ color: BRAND, fontSize: "1rem" }}
                    >
                      ديون النقطة
                    </Typography>
                    <Typography
                      variant="h6"
                      fontWeight="700"
                      sx={{ color: BRAND, fontSize: "1.1rem" }}
                    >
                      {_JOrder.pos_j_balance?.toLocaleString()} IQD
                    </Typography>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card
              sx={{
                background: alpha(BRAND, 0.08),
                border: `1px solid ${alpha(BRAND, 0.2)}`,
                borderRadius: 3,
                boxShadow: `0 8px 32px ${alpha(BRAND, 0.12)}`,
                transition: "all 0.3s ease-in-out",
                height: 400,
                display: "flex",
                flexDirection: "column",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: `0 12px 40px ${alpha(BRAND, 0.2)}`,
                },
              }}
            >
              <CardContent
                sx={{ p: 3, flex: 1, display: "flex", flexDirection: "column" }}
              >
                <Box sx={{ mb: 2.5 }}>
                  <Typography
                    variant="h5"
                    fontWeight="700"
                    sx={{
                      color: BRAND,
                      fontSize: "1.3rem",
                      letterSpacing: "-0.02em",
                    }}
                  >
                    حالة الطلب
                  </Typography>
                </Box>

                <Stack spacing={2} sx={{ flex: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1.5,
                      px: 2,
                      bgcolor: "rgba(255, 255, 255, 0.6)",
                      borderRadius: 2,
                      border: `1px solid ${alpha(BRAND, 0.1)}`,
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="600"
                      sx={{ color: BRAND, fontSize: "1rem" }}
                    >
                      الحالة
                    </Typography>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <ChangeStatusByChip
                        id={_JOrder.j_order_status_id}
                        status={_JOrder.j_order_status_name}
                        onChangeStatus={(item) => {
                          changeOrderStatus(_JOrder.id, item);
                        }}
                      />
                      <Tooltip title="حالات الطلب" followCursor>
                        <IconButton
                          size="small"
                          sx={{
                            color: BRAND,
                            bgcolor: alpha(BRAND, 0.1),
                            "&:hover": { bgcolor: alpha(BRAND, 0.2) },
                          }}
                          onClick={() => {
                            dispatch(
                              setOrderStatusHistoryDialog(
                                _JOrder.status_history
                              )
                            );
                          }}
                        >
                          <MdList size={18} />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1.2,
                      px: 2,
                      bgcolor: "rgba(255, 255, 255, 0.6)",
                      borderRadius: 2,
                      border: `1px solid ${alpha(BRAND, 0.1)}`,
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="600"
                      sx={{ color: BRAND, fontSize: "1rem" }}
                    >
                      عدد المنتجات الكلي
                    </Typography>
                    <Typography
                      variant="h6"
                      fontWeight="700"
                      sx={{ color: BRAND, fontSize: "1.1rem" }}
                    >
                      {_JOrder?.items_count?.toLocaleString()}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1.2,
                      px: 2,
                      bgcolor: alpha(TONE.danger, 0.08),
                      borderRadius: 2,
                      border: `1px solid ${alpha(TONE.danger, 0.3)}`,
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="600"
                      sx={{ color: TONE.danger, fontSize: "1rem" }}
                    >
                      الخصم
                    </Typography>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Box sx={{ textAlign: "right" }}>
                        <Typography
                          variant="h6"
                          fontWeight="700"
                          sx={{
                            color: TONE.danger,
                            lineHeight: 1.2,
                            fontSize: "1.1rem",
                          }}
                        >
                          {(_JOrder.discount || 0)?.toLocaleString()} IQD
                        </Typography>
                        {_JOrder.admin_discount > 0 && (
                          <Typography
                            variant="body2"
                            sx={{
                              color: TONE.danger,
                              opacity: 0.8,
                              fontSize: "0.8rem",
                              display: "block",
                            }}
                          >
                            + {_JOrder.admin_discount?.toLocaleString()} (خصم
                            الشركة)
                          </Typography>
                        )}
                      </Box>
                      <Tooltip title="تعديل الخصم">
                        <IconButton
                          size="small"
                          sx={{
                            bgcolor: alpha(BRAND, 0.1),
                            color: BRAND,
                            "&:hover": {
                              bgcolor: alpha(BRAND, 0.2),
                              transform: "scale(1.1)",
                            },
                            transition: "all 0.2s ease-in-out",
                          }}
                          onClick={() => {
                            dispatch(
                              setAdminDiscountDialog({
                                id: _JOrder.id,
                                net_amount: _JOrder.net_amount,
                                amount: _JOrder.amount,
                                admin_discount: _JOrder.admin_discount,
                                admin_discount_percent:
                                  Math.round(
                                    (_JOrder.admin_discount / _JOrder.amount) *
                                      100 *
                                      100
                                  ) / 100,
                              })
                            );
                          }}
                        >
                          <BiEdit size={16} />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card
              sx={{
                background: alpha(BRAND, 0.08),
                border: `1px solid ${alpha(BRAND, 0.2)}`,
                borderRadius: 3,
                boxShadow: `0 8px 32px ${alpha(BRAND, 0.12)}`,
                transition: "all 0.3s ease-in-out",
                height: 400,
                display: "flex",
                flexDirection: "column",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: `0 12px 40px ${alpha(BRAND, 0.2)}`,
                },
              }}
            >
              <CardContent
                sx={{ p: 3, flex: 1, display: "flex", flexDirection: "column" }}
              >
                <Box sx={{ mb: 2.5 }}>
                  <Typography
                    variant="h5"
                    fontWeight="700"
                    sx={{
                      color: BRAND,
                      fontSize: "1.3rem",
                      letterSpacing: "-0.02em",
                    }}
                  >
                    تفاصيل إضافية
                  </Typography>
                </Box>

                <Stack spacing={2} sx={{ flex: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1.2,
                      px: 2,
                      bgcolor: "rgba(255, 255, 255, 0.6)",
                      borderRadius: 2,
                      border: `1px solid ${alpha(BRAND, 0.1)}`,
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="600"
                      sx={{ color: BRAND, fontSize: "1rem" }}
                    >
                      تاريخ الطلب
                    </Typography>
                    <Chip
                      label={dayjs(_JOrder.created_at).format("YYYY-MM-DD")}
                      size="medium"
                      sx={{
                        fontWeight: "bold",
                        bgcolor: BRAND,
                        color: "white",
                        fontSize: "0.85rem",
                      }}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1.2,
                      px: 2,
                      bgcolor: "rgba(255, 255, 255, 0.6)",
                      borderRadius: 2,
                      border: `1px solid ${alpha(BRAND, 0.1)}`,
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="600"
                      sx={{ color: BRAND, fontSize: "1rem" }}
                    >
                      المبلغ الكلي
                    </Typography>
                    <Typography
                      variant="h6"
                      fontWeight="700"
                      sx={{ color: BRAND, fontSize: "1.1rem" }}
                    >
                      {_JOrder.net_amount?.toLocaleString()} IQD
                    </Typography>
                  </Box>

                  {(_Role === "super_admin" ||
                    _UserInfo?.id === PRIVILEGED_USER_ID) && (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          py: 1.2,
                          px: 2,
                          bgcolor: "rgba(255, 255, 255, 0.6)",
                          borderRadius: 2,
                          border: `1px solid ${alpha(BRAND, 0.1)}`,
                        }}
                      >
                        <Typography
                          variant="body1"
                          fontWeight="600"
                          sx={{ color: BRAND, fontSize: "1rem" }}
                        >
                          الارباح
                        </Typography>
                        <Typography
                          variant="h6"
                          fontWeight="700"
                          sx={{ color: BRAND, fontSize: "1.1rem" }}
                        >
                          {toNumber(_JOrder.net_revenue ?? 0)?.toLocaleString()}{" "}
                          IQD
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          py: 1.2,
                          px: 2,
                          bgcolor: "rgba(255, 255, 255, 0.6)",
                          borderRadius: 2,
                          border: `1px solid ${alpha(BRAND, 0.1)}`,
                        }}
                      >
                        <Typography
                          variant="body1"
                          fontWeight="600"
                          sx={{ color: BRAND, fontSize: "1rem" }}
                        >
                          نسبة الربح
                        </Typography>
                        <Typography
                          variant="h6"
                          fontWeight="700"
                          sx={{ color: BRAND, fontSize: "1.1rem" }}
                        >
                          {_JOrder?.net_revenue_percentage} %
                        </Typography>
                      </Box>
                    </>
                  )}

                  {_JOrder.note && (
                    <Box
                      sx={{
                        py: 1.5,
                        px: 2,
                        bgcolor: "rgba(255, 255, 255, 0.6)",
                        borderRadius: 2,
                        border: `1px solid ${alpha(BRAND, 0.1)}`,
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontWeight="600"
                        sx={{
                          color: BRAND,
                          mb: 0.5,
                          display: "block",
                          fontSize: "0.9rem",
                        }}
                      >
                        الملاحظات:
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          color: "#374151",
                          wordWrap: "break-word",
                          lineHeight: 1.5,
                          fontSize: "0.95rem",
                          fontStyle: _JOrder.note ? "normal" : "italic",
                        }}
                      >
                        {_JOrder.note || "لا توجد ملاحظات"}
                      </Typography>
                    </Box>
                  )}

                  {_JOrder.admin_note && (
                    <Box
                      sx={{
                        py: 1.5,
                        px: 2,
                        bgcolor: alpha(TONE.success, 0.08),
                        borderRadius: 2,
                        border: `1px solid ${alpha(TONE.success, 0.3)}`,
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontWeight="600"
                        sx={{
                          color: TONE.success,
                          mb: 0.5,
                          display: "block",
                          fontSize: "0.9rem",
                        }}
                      >
                        ملاحظات الادمن:
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          color: "#374151",
                          wordWrap: "break-word",
                          lineHeight: 1.5,
                          fontSize: "0.95rem",
                          fontStyle: _JOrder.admin_note ? "normal" : "italic",
                        }}
                      >
                        {_JOrder.admin_note || "لا توجد ملاحظات إدارية"}
                      </Typography>
                    </Box>
                  )}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
          {smallScreen ? (
            <Grid item xs={12}>
              <MobileListShell loading={_JOrder.loading}>
                <MobileSectionTitle
                  title="منتجات الطلب"
                  icon={<HiOutlineShoppingBag />}
                />
                {_JOrder.items?.map((item, index) => (
                  <Fade in={true} timeout={300 + index * 100} key={index}>
                    <Box>
                      <MobileListItem
                        avatar={index + 1}
                        avatarTone={item.is_canceled ? TONE.danger : BRAND}
                        title={item.j_item_name}
                        titleStrikeThrough={item.is_canceled}
                        subtitle={
                          [item.j_sub_category_name, item.code]
                            .filter(Boolean)
                            .join(" · ") || undefined
                        }
                        badge={
                          item.is_canceled ? (
                            <MobileBadge label="ملغي" tone={TONE.danger} />
                          ) : duplicateItems.has(item.id) ? (
                            <Tooltip title="منتج مكرر - يوجد منتج آخر بنفس الكود">
                              <Box>
                                <MobileBadge
                                  label="مكرر"
                                  tone={TONE.warning}
                                />
                              </Box>
                            </Tooltip>
                          ) : null
                        }
                        media={
                          item.logo?.[0]?.path ? (
                            <Box
                              component="img"
                              src={item.logo[0].path}
                              alt={item.j_item_name}
                              width={120}
                              height={120}
                              sx={{
                                objectFit: "contain",
                                borderRadius: 2,
                                bgcolor: "#f9fafb",
                                border: "1px solid #f2f4f7",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setAttachmentsData(item.logo);
                                setOpenCarouselDialog(true);
                              }}
                            />
                          ) : null
                        }
                        highlight={{
                          label: "المبلغ الكلي",
                          value: (item.total ?? 0).toLocaleString(),
                          unit: "IQD",
                        }}
                        fields={[
                          {
                            label: "السعر قبل الخصم",
                            value:
                              item.price_before_discount?.toLocaleString(),
                          },
                          {
                            label: "الخصم للقطعة",
                            value: item.discount_for_one?.toLocaleString(),
                          },
                          {
                            label: "سعر المنتج",
                            value: item.price?.toLocaleString(),
                          },
                          {
                            label: "العدد",
                            value: item.count?.toLocaleString(),
                          },
                          {
                            label: "الخصم الكلي",
                            span:
                              _Role === "super_admin" ||
                              _UserInfo?.id === PRIVILEGED_USER_ID
                                ? 6
                                : 12,
                            value: item.total_discount?.toLocaleString(),
                          },
                          ...(_Role === "super_admin" ||
                          _UserInfo?.id === PRIVILEGED_USER_ID
                            ? [
                                {
                                  label: "سعر الشراء",
                                  value:
                                    item.last_buying_price?.toLocaleString(),
                                },
                                {
                                  label: "صافي الربح (IQD)",
                                  span: 12,
                                  value: toNumber(
                                    item.net_revenue
                                  )?.toLocaleString(),
                                },
                              ]
                            : []),
                        ]}
                        actions={
                          _Role === "representative" ? null : (
                            <>
                              {item.is_canceled ? null : (
                                <MobileAction
                                  title="تعديل الكمية"
                                  icon={<FaCartPlus />}
                                  onClick={() => {
                                    setDialogType("update");
                                    setItemCount(item.count);
                                    setOpenItemDialog(true);
                                    setDialogData(item);
                                  }}
                                />
                              )}
                              <MobileAction
                                title="تعديل خصم العنصر"
                                tone={TONE.success}
                                icon={<FaTicketAlt />}
                                onClick={() => {
                                  dispatch(
                                    setOrderItemDiscountDialog({
                                      orderId: order_id,
                                      id: item.id,
                                      price: item.price,
                                      price_before_discount:
                                        item.price_before_discount,
                                      total_discount: 0,
                                      total_discount_percent: 0,
                                    })
                                  );
                                }}
                              />
                              <MobileAction
                                title={
                                  item.is_canceled
                                    ? "استرداد المادة"
                                    : "الغاء المادة"
                                }
                                tone={
                                  item.is_canceled ? TONE.success : TONE.danger
                                }
                                icon={<MdOutlineCancel />}
                                onClick={() => {
                                  setDialogType("cancel");
                                  setItemCount(item.count);
                                  setOpenItemDialog(true);
                                  setDialogData(item);
                                }}
                              />
                            </>
                          )
                        }
                      />
                    </Box>
                  </Fade>
                ))}
              </MobileListShell>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Paper
                sx={{
                  borderRadius: 2,
                  overflow: "hidden",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                }}
              >
                <Box
                  sx={{
                    p: 3,
                    background: BRAND_GRADIENT,
                    color: "white",
                  }}
                >
                  <Typography variant="h5" fontWeight="600">
                    منتجات الطلب
                  </Typography>
                </Box>
                <DataGrid
                  rows={
                    _JOrder?.items?.map((x, i) => {
                      return {
                        ...x,
                        index: i + 1,
                      };
                    }) || []
                  }
                  columns={columns}
                  rowCount={_JOrder?.total}
                  loading={loading}
                  rowHeight={160}
                  autoHeight
                  pagination
                  paginationMode="client"
                  selectionModel={[]}
                  rowsPerPageOptions={[15, 25, 50, 100]}
                  components={{
                    LoadingOverlay: LinearProgress,
                  }}
                  sx={{
                    border: "none",
                    "& .MuiDataGrid-root": {
                      borderRadius: 0,
                    },
                    "& .MuiDataGrid-cell": {
                      borderBottom: "1px solid rgba(224, 224, 224, 0.3)",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#f8fafc",
                      borderBottom: "2px solid #e2e8f0",
                      "& .MuiDataGrid-columnHeader": {
                        fontWeight: 600,
                        fontSize: "0.875rem",
                      },
                    },
                    "& .MuiDataGrid-row": {
                      "&:hover": {
                        backgroundColor: alpha(BRAND, 0.04),
                      },
                      "&.Mui-selected": {
                        backgroundColor: alpha(BRAND, 0.08),
                        "&:hover": {
                          backgroundColor: alpha(BRAND, 0.12),
                        },
                      },
                    },
                    "& .MuiDataGrid-footerContainer": {
                      borderTop: "2px solid #e2e8f0",
                      backgroundColor: "#f8fafc",
                    },
                  }}
                />
              </Paper>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default JOrderDetails;
